import { render } from "./PostFilters.vue?vue&type=template&id=33fec775&scoped=true"
import script from "./PostFilters.vue?vue&type=script&lang=js"
export * from "./PostFilters.vue?vue&type=script&lang=js"

import "./post-filters.scss?vue&type=style&index=0&id=33fec775&lang=scss&scoped=true"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fec775"]])

export default __exports__